const NAVIGATION_V2_APP_RETURN_PATH_KEY = "chalk-navigation-v2-app-return-path";

export const getNavigationV2AppReturnPath = () => {
  if (typeof window === "undefined") return undefined;

  return window.localStorage.getItem(NAVIGATION_V2_APP_RETURN_PATH_KEY) ?? undefined;
};

export const setNavigationV2AppReturnPath = (path: string) => {
  if (typeof window === "undefined") return;

  window.localStorage.setItem(NAVIGATION_V2_APP_RETURN_PATH_KEY, path);
};
